import { render, staticRenderFns } from "./layout-login.vue?vue&type=template&id=2d0dcd87"
import script from "./layout-login.vue?vue&type=script&lang=js"
export * from "./layout-login.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports